// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Select-value {
  display: 'flex';
  margin: '0';
  align-items: 'center';
  font-size: '1rem';
}

.Select,
.Select div,
.Select input,
.Select span {
  border-radius: '0';
}

.Select.has-value.Select--single
  > .Select-control
  .Select-value
  .Select-value-label {
  font-size: '1rem';
  width: '100%';
  text-align: 'left';
  color: 'hsl(0, 0%, 50%)';
}

.Center .Select-placeholder {
  text-align: 'left';
  padding-right: '30px !important';
}

.Big .Select-placeholder {
  padding-top: '6px';
  font-size: '1.4rem';
}

.Select-menu {
  max-height: '398px';
}

.Center .Select-value {
  text-align: 'center';
  padding-right: '30px !important';
}

.Big .Select-value {
  padding-top: '6px';
  font-size: '1.4rem';
}

.Big .Select-input {
  padding-top: '6px';
  font-size: '1.4rem';
}
`, "",{"version":3,"sources":["webpack://./css/select.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;;;;EAIE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB","sourcesContent":[".Select-value {\n  display: 'flex';\n  margin: '0';\n  align-items: 'center';\n  font-size: '1rem';\n}\n\n.Select,\n.Select div,\n.Select input,\n.Select span {\n  border-radius: '0';\n}\n\n.Select.has-value.Select--single\n  > .Select-control\n  .Select-value\n  .Select-value-label {\n  font-size: '1rem';\n  width: '100%';\n  text-align: 'left';\n  color: 'hsl(0, 0%, 50%)';\n}\n\n.Center .Select-placeholder {\n  text-align: 'left';\n  padding-right: '30px !important';\n}\n\n.Big .Select-placeholder {\n  padding-top: '6px';\n  font-size: '1.4rem';\n}\n\n.Select-menu {\n  max-height: '398px';\n}\n\n.Center .Select-value {\n  text-align: 'center';\n  padding-right: '30px !important';\n}\n\n.Big .Select-value {\n  padding-top: '6px';\n  font-size: '1.4rem';\n}\n\n.Big .Select-input {\n  padding-top: '6px';\n  font-size: '1.4rem';\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
